import { useMutation } from '@tanstack/react-query';
import { createContentFromUrl } from '../../services';

export function useCreateContentFromUrl() {
  return useMutation(createContentFromUrl, { onSuccess: (data) => data });
}
